<!--
 * @Description: 校历课表
 * @Author: 王赵坤
 * @Date: 2022-10-27 10:55:02
 * @LastEditors: PF
 * @LastEditTime: 2026-09-07 17:01:51
-->

<template>
  <div class="list-page">
    <el-container class="hp100">
      <el-aside width="200px">
        <el-container class="hp100">
          <el-header>
            <el-select v-model="xqid" placeholder="学期" style="width:100px;margin-bottom:10px;" clearable filterable @change="xveqichaxvn">
              <el-option v-for="(item) in allXq" :key="item.id" :label="item.xqmc" :value="item.id" />
            </el-select>
            <el-select v-model="zcid" placeholder="周次" style="width:100px;margin-bottom:10px;" clearable filterable @change="zhouci">
              <el-option v-for="item in allzc" :key="item.id" :label="'第'+item.zc+'周'" :value="item.zc" />
            </el-select>
            <div class="button-box">
              <el-select v-model="cxtj">
                <el-option label="班级课表" :value=2 />
                <el-option label="教师课表" :value=1 />
                <el-option label="教学场地课表" :value=3 />
              </el-select>
              <!-- 机构 -->
              <el-select v-model="sxtj" placeholder="Select" clearable filterable @change="sxtjget" v-show="cxtj==1">
                <el-option label="全部机构" :value="1" />
                <el-option label="未设置机构" :value="0" />
                <el-option v-for="item in jigoulist" :key="item.id" :label="item.jgmc" :value="item.id" />
              </el-select>
              <!-- 专业 -->
              <el-select v-model="sxtj" placeholder="Select" clearable filterable @change="sxtjget" v-show="cxtj==2">
                <el-option label="全部专业" :value="2" />
                <el-option v-for="item in zylist" :key="item.id" :label="item.zymc" :value="item.id" />
              </el-select>
              <!-- 教学楼 -->
              <el-select v-model="sxtj" placeholder="Select" clearable filterable @change="sxtjget" v-show="cxtj==3">
                <el-option label="全部教学楼" :value="3" />
                <el-option label="未设置教学楼" :value="0" />
                <el-option v-for="item in jzwlist" :key="item.id" :label="item.jzwmc" :value="item.id" />
              </el-select>
              <el-input class="input-with-select" placeholder="请输入内容" v-model="keyword" clearable @clear="caxxvn()" @keyup.enter="caxxvn()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="caxxvn()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </div>
          </el-header>
          <el-main>
            <el-tree v-if="cxtj==1" :data="jzgsall" default-expand-all highlight-current :props="{ children: 'children', label: 'xm' }" @node-click="handleNodeClick" />
            <el-tree v-if="cxtj==2" :data="bjsall" default-expand-all highlight-current :props="{ children: 'children', label: 'mc' }" @node-click="handleNodeClick" />
            <el-tree v-if="cxtj==3" :data="jxcdsall" default-expand-all highlight-current :props="{ children: 'children', label: 'jsmc' }" @node-click="handleNodeClick" />
          </el-main>
        </el-container>
      </el-aside>
      <el-main class="ml10 mb0">
        <el-container>
          <el-header>
            <el-button type="info" @click="exportBanJiKeBiao" style="margin:0 10px 10px 0;"><el-icon class="el-icon--left"><DocumentCopy /></el-icon>导出班级课表</el-button>
            <!-- <el-button type="info" @click="exportJiaoZhiGongKeBiao" style="margin:0 10px 10px 0;"><el-icon class="el-icon--left"><DocumentCopy /></el-icon>导出教师课表</el-button>
            <el-button type="info" @click="exportJiaoShiKeBiao" style="margin:0 10px 10px 0;"><el-icon class="el-icon--left"><DocumentCopy /></el-icon>导出教室课表</el-button>
            <el-button type="info" @click="exportAllKeBiao" style="margin:0 10px 10px 0;"><el-icon class="el-icon--left"><DocumentCopy /></el-icon>导出全部课表</el-button> -->
            <el-button type="primary" @click="openBangZhu=true" style="margin:0 10px 10px 0;">? 帮助说明</el-button>
            <div class="operation-total" v-if="cxtj==2">
              <span style="font-size: 16px;">{{bjform.mc}}</span>
              <span style="font-size: 16px;" v-if="bjform.mc"></span>
              <span style="font-size: 16px;">班主任：{{bjform.zxs}}</span>
              <span style="font-size: 16px;">年级:{{bjform.ypxs}}</span>
              <span style="font-size: 16px;">专业:{{bjform.syxs}}</span>
            </div>
          </el-header>
          <el-main>
            <jiaoShiKebiao :jslistdata="jslistdata" :xqid="xqid" :zcid="zcid" v-show="cxtj==1" @chuanshujvxl="chuanshujvxl" />
            <banJiKeBiao :bilistdata="bilistdata" :xqid="xqid" :bjloading="bjloading" :zcid="zcid" @falseloding="falsebjloading" @chuanshujvxl="chuanshujvxl" :bjid="bjid" v-show="cxtj==2" />
            <jiaoXveChangDikebiao :jxcdlistdata="jxcdlistdata" :xqid="xqid" :zcid="zcid" v-show="cxtj==3" @chuanshujvxl="chuanshujvxl" />
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
  <bangzhushuoming v-if="openBangZhu" v-model:openDetail="openBangZhu" />
</template>

<script setup>
import { ref, watch, defineEmits } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { loadSelect, actionPost, exportExcel } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import banJiKeBiao from '../paikerenwu/xiaolibanjikebiao.vue' // 班级课表
import jiaoShiKebiao from '../paikerenwu/xiaolijiaoshikebiao.vue' // 教师课表
import jiaoXveChangDikebiao from '../paikerenwu/xiaolijiaoxvechangdikebiao.vue' // 教学场地课表
import bangzhushuoming from '@/components/bangzhu/bangzhushuoming.vue'

const row = ref()
const openBangZhu = ref(false)

const emits = defineEmits(['gochuanshujvxl'])
const bjloading = ref(false)
const cxtj = ref(2) // 查询条件
const sxtj = ref(null) // 筛选条件
const xqid = ref('') // 学期id
const zcid = ref() // 周次 id
const allXq = ref([]) // 学期
const allzc = ref([]) // 周次
const jzgsall = ref([]) // 教师树形控件
const bjsall = ref([]) // 班级树
const jxcdsall = ref([]) // 教学场地
const zylist = ref([]) // 专业
const jzwlist = ref([]) // 建筑物
const jigoulist = ref([]) // 机构
const bjid = ref('') // 班级id
const jzgid = ref('') // 教职工id
const jxcdid = ref('') // 教学场地id
const bilistdata = ref([]) // 班级数据
const jslistdata = ref([]) // 教师数据
const jxcdlistdata = ref([]) // 教学场地数据
const keyword = ref('') // 关键字查询
const bjform = ref({ syxs: '', ypxs: '', zxs: '' }) // 班级总学时
const falsebjloading = () => {
  bjloading.value = false
}
// 传数据
const gochuanshujvxl = (val, time, number) => {
  emits('gochuanshujvxl', val, time, number)
}
const chuanshujvxl = (val, time, number) => {
  gochuanshujvxl(val, time, number)
}
// 获取学期数据
const getxqlist = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: allXq,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          xqid.value = element.id
        }
      })
      getzouci()
      sxtjget()
    }
  })
  // getxueqiList().then((res) => {
  //   allXq.value = res.data
  //   res.data.forEach((item) => {
  //     if (item.sfdqxq === true) {
  //       xqid.value = item.id
  //     }
  //   })
  //   getzouci()
  //   sxtjget()
  // })
}
// 获取周次
const getzouci = () => {
  const zcs = []
  allzc.value = []
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaoli/xiaoLiRiQi',
    data: {
      xqid: xqid.value
    }
  }).then((res) => {
    res.data.forEach((item) => {
      if (zcs.indexOf(item.zc) === -1) {
        zcs.push(item.zc)
        allzc.value.push(item)
      }
    })
    zcid.value = res.data[0].zc
  })
}
// 专业
const zylistall = () => {
  actionPost({
    url: '/api/v2/pdp/zhuanye/list',
    data: {}
  }).then((res) => {
    zylist.value = res.data
  })
}
// 机构
const jigouall = () => {
  actionPost({
    url: '/api/v2/xiaoneijigou/list',
    data: {}
  }).then((res) => {
    jigoulist.value = res.data
  })
}
// 班级树
const bjall = () => {
  let obj = {}
  if (sxtj.value === 1 || sxtj.value === 2 || sxtj.value === 3) {
    obj = { xqid: xqid.value, keyword: keyword.value }
  } else {
    obj = { xqid: xqid.value, zyid: sxtj.value, keyword: keyword.value }
  }
  actionPost({
    url: '/api/v2/pdp/banji/tree/by_nianji',
    data: obj
  }).then((res) => {
    bjsall.value = res.data || []
  })
}
// 教职工树
const jzgall = () => {
  if (sxtj.value === 1 || sxtj.value === 2 || sxtj.value === 3) {
    const o = {
      url: '/api/v2/pdp/jiaozhigong/tree/by_jiaoshi_binglie',
      data: {
        xm: keyword.value
      }
    }
    actionPost(o).then((res) => {
      jzgsall.value = res.data || []
    })
  } else {
    const o = {
      url: '/api/v2/pdp/jiaozhigong/tree/by_jiaoshi_binglie',
      data: {
        jgid: sxtj.value,
        xm: keyword.value
      }
    }
    actionPost(o).then((res) => {
      jzgsall.value = res.data || []
    })
  }
}
// 教学场地树
const jxcdall = () => {
  let obj = {}
  if (sxtj.value === 1 || sxtj.value === 2 || sxtj.value === 3) {
    obj = { jsmc: keyword.value }
  } else {
    obj = { jzwid: sxtj.value, jsmc: keyword.value }
  }
  actionPost({
    url: '/api/v2/zichan/jiaoxuechangdi/tree/by_jianzhuwu',
    data: obj
  }).then((res) => {
    jxcdsall.value = res.data || []
  })
}
// 建筑物
const jzwall = () => {
  actionPost({
    url: '/api/v2/zichan/jianzhuwu/list',
    data: {}
  }).then((res) => {
    jzwlist.value = res.data
  })
}
// 筛选条件查询
const sxtjget = () => {
  if (cxtj.value === 1) {
    jzgall()
  } else if (cxtj.value === 2) {
    bjall()
  } else if (cxtj.value === 3) {
    jxcdall()
  }
}
// 班级课表结构数据
const getbjlistdata = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/banji',
    data: { bjid: bjid.value, xqid: xqid.value, zc: zcid.value }
  }).then((res) => {
    bilistdata.value = res.data
  })
}
// 教师课表结构数据
const getjslistdata = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/zhidingjiaoshi',
    data: { jsid: jzgid.value, xqid: xqid.value, zc: zcid.value }
  }).then((res) => {
    jslistdata.value = res.data
  })
}
// 教学场地课表结构数据
const getjxcdlistdata = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/jiaoixuechangdi',
    data: { jxcdid: jxcdid.value, xqid: xqid.value, zc: zcid.value }
  }).then((res) => {
    jxcdlistdata.value = res.data
  }
  )
}
// 学期周次集合查询
// const xveqizcjh = () => {
//   if (cxtj.value === 1) {
//     getjslistdata()
//   } else if (cxtj.value === 2) {
//     getbjlistdata()
//   } else if (cxtj.value === 3) {
//     getjxcdlistdata()
//   }
// }
// 查询关键字
const caxxvn = () => {
  if (cxtj.value === 1) {
    jzgall()
  } else if (cxtj.value === 2) {
    bjall()
  } else if (cxtj.value === 3) {
    jxcdall()
  }
}
// 点击树形控件
const dqbj = ref()
const handleNodeClick = (data) => {
  dqbj.value = data || dqbj.value
  //
  //
  if (cxtj.value === 1) {
    jzgid.value = dqbj.value.id
    bjform.value.mc = dqbj.value.xm
    getjslistdata()
    jszxs()
  } else if (cxtj.value === 2) {
    bjid.value = dqbj.value.id
    bjform.value.mc = dqbj.value.mc
    getbjlistdata()
    bjform.value.syxs = dqbj.value.zymc
    bjform.value.ypxs = dqbj.value.njmc
    bjform.value.zxs = dqbj.value.bzrxm
    // banjizks()
  } else if (cxtj.value === 3) {
    jxcdid.value = dqbj.value.id
    bjform.value.mc = dqbj.value.jsmc
    getjxcdlistdata()
    jxcdzxs()
  }
}
// 班级总课时
// const banjizks = () => {
//   gettjbjzxs({
//     bjid: bjid.value
//   }).then(res => {
//     //
//     bjform.value.syxs = res.data.syxs
//     bjform.value.ypxs = res.data.ypxs
//     bjform.value.zxs = res.data.zxs
//   })
// }
const jszxs = () => {
  const o = {
    url: '/api/v2/jiaowu/jiaowupaikekebiao/jiaoshikeshi',
    data: { jsid: jzgid.value }
  }
  actionPost(o).then((res) => {
    //
    bjform.value.syxs = res.data.syxs
    bjform.value.ypxs = res.data.ypxs
    bjform.value.zxs = res.data.zxs
  })
}
const jxcdzxs = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowupaikekebiao/jiaoxuechangdikeshi',
    data: { jxcdid: jxcdid.value }
  }).then((res) => {
    bjform.value.syxs = res.data.syxs
    bjform.value.ypxs = res.data.ypxs
    bjform.value.zxs = res.data.zxs
  })
}
// 学期查询
const xveqichaxvn = () => {
  caxxvn()
  getzouci()
}
// 切换里周次
const zhouci = () => {
  handleNodeClick()
}
// watch(
//   () => props.seeObj,
//   () => {
//     if (props.seeObj) {
//       title.value = props.seeObj.title
//       xqid.value = props.seeObj.xqid
//       perwid.value = props.seeObj.pkrwid
//       cxtj.value = 2
//       bilistdata.value = []
//       jslistdata.value = []
//       jxcdlistdata.value = []
//       bjform.value = {}
//       getxqlist()
//       getpkruall()
//       bjall()
//     } else {
//       ruleForm.value = {}
//     }
//   },
//   { deep: true, immediate: true }
// )
// 监听区域
watch(
  () => xqid,
  () => {
    if (xqid.value) {
      bilistdata.value = []
      jslistdata.value = []
      jxcdlistdata.value = []
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => cxtj,
  () => {
    if (cxtj.value) {
      if (cxtj.value === 1) {
        sxtj.value = 1
        keyword.value = ''
        jigouall()
        jzgall()
      } else if (cxtj.value === 2) {
        sxtj.value = 2
        keyword.value = ''
        zylistall()
        bjall()
      } else if (cxtj.value === 3) {
        sxtj.value = 3
        keyword.value = ''
        jxcdall()
        jzwall()
      }
    }
  },
  { deep: true, immediate: true }
)
// 执行区域
getxqlist()

// Excel导出
const exportBanJiKeBiao = async () => {
  if (!xqid.value) {
    return warningPrompt('请选择学期')
  }
  if (bjsall.value.length === 0) {
    return warningPrompt('暂无班级课表')
  }
  const data = { parms: { xqid: xqid.value } }
  exportExcel('/api/v2/jiaowu/jiaowuxiaolikebiao/exportBanJiKeBiao', data)
}

const exportJiaoZhiGongKeBiao = async () => {
  if (!xqid.value) {
    return warningPrompt('请选择学期')
  }
  if (jzgsall.value.length === 0) {
    return warningPrompt('暂无教师课表')
  }
  const data = { parms: { xqid: xqid.value } }
  exportExcel('/api/v2/jiaowu/jiaowuxiaolikebiao/exportJiaoZhiGongKeBiao', data)
}

const exportJiaoShiKeBiao = async () => {
  if (!xqid.value) {
    return warningPrompt('请选择学期')
  }
  if (jxcdsall.value.length === 0) {
    return warningPrompt('暂无教室课表')
  }
  const data = { parms: { xqid: xqid.value } }
  exportExcel(
    '/api/v2/jiaowu/jiaowuxiaolikebiao/exportJiaoXueChangDiKeBiao',
    data
  )
}

const exportAllKeBiao = async () => {
  if (!xqid.value) {
    return warningPrompt('请选择学期')
  }
  const data = { parms: { xqid: xqid.value } }
  exportExcel('/api/v2/jiaowu/jiaowuxiaolikebiao/exportAllKeBiao', data)
}
</script>

<style lang="less" scoped>
.box {
  width: 99%;
  height: 67vh;
  margin-left: 10px;
}
:deep.el-header {
  --el-header-padding: 0 0px;
  --el-header-height: 50px;
}
:deep.el-dialog__body {
  padding: 10px 20px;
}
.scrollbar-demo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  margin: 10px;
  text-align: center;
  border-radius: 4px;
  background: var(--el-color-primary-light-9);
  color: var(--el-color-primary);
}
.operation-total {
  width: 600px;
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
}
:deep.el-main {
  --el-main-padding: 0px;
}
.input-with-select .el-input-group__prepend {
  background-color: var(--el-fill-color-blank);
}
</style>
